import axios from 'axios';
import { api } from './api'; 

export const API_MESSENGER_URL = 'https://diamondmessenger.liara.run'
//export const API_MESSENGER_URL = 'http://localhost:9000'

const messengerApi = axios.create({
  baseURL: API_MESSENGER_URL,
  timeout: 100000,
});

messengerApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const messengerService = {
  // Customer endpoints
  askQuestion: (customerId, question, department = 'financial', companyId = null) =>
    messengerApi.post('/customer/question', {
      customer_id: customerId,
      question,
      department,
      company_id: companyId
    }),

  getChatStatus: (customerId) =>
    messengerApi.get(`/customer/chat_status/${customerId}`),

  // Operator endpoints
  registerOperator: (operatorData) =>
    messengerApi.post('/operator/register', operatorData),

  updateOperatorStatus: (operatorId, status) =>
    messengerApi.post('/operator/status', {
      operator_id: operatorId,
      status
    }),

  getOperatorStats: (department) =>
    messengerApi.get(`/operator/stats/${department}`),

  getPendingQuestions: (department = null) =>
      messengerApi.get('/pending/questions', { 
          params: department ? { department } : {} 
      })
      .then(response => {
          // Log the response for debugging
          console.log('Pending questions response:', response.data)
          return response.data
      }),

  acceptQuestion: (operatorId, customerId, department) =>
    messengerApi.post('/operator/accept', {
      operator_id: operatorId,
      customer_id: customerId,
      department
    }),

  getActiveChats: (operatorId) =>
    messengerApi.get(`/operator/active_chats/${operatorId}`),

  closeChat: (chatId) =>
    messengerApi.post('/operator/close_chat', { chat_id: chatId }),

  // Chat message endpoints
  sendChatMessage: (chatId, senderId, message, senderType) =>
    messengerApi.post('/chat/send', {
      chat_id: chatId,
      sender_id: senderId,
      message,
      sender_type: senderType
    }),

  getChatMessages: (chatId) =>
    messengerApi.get(`/chat/get/${chatId}`),

  // User lookup
  findUser: (username) =>
    messengerApi.get(`/find/${username}`),

  // Registration for messenger
  registerUser: (userData) =>
    messengerApi.post('/register', userData),

  // File handling
  uploadFile: async (formData, chatId, senderId) => {
    // First, get upload URL from your main backend
    const uploadConfig = await api.post('/messenger/get-upload-url', {
      filename: formData.get('file').name,
      file_type: formData.get('file').type,
      chat_id: chatId,
      sender_id: senderId
    });

    // Upload to the signed URL (External/Direct)
    await axios.put(uploadConfig.data.upload_url, formData.get('file'), {
      headers: { 'Content-Type': formData.get('file').type }
    });

    // Notify messenger server
    return messengerApi.post('/chat/file/uploaded', {
      chat_id: chatId,
      sender_id: senderId,
      file_url: uploadConfig.data.file_url,
      filename: formData.get('file').name,
      file_size: formData.get('file').size,
      file_type: formData.get('file').type
    });
  },

  sendFile: (chatId, senderId, file, senderType) => {
    const formData = new FormData();
    formData.append('chat_id', chatId);
    formData.append('sender_id', senderId);
    formData.append('file', file);
    formData.append('sender_type', senderType);
    formData.append('filename', file.name);
    formData.append('file_size', file.size);
    formData.append('file_type', file.type);

    return messengerApi.post('/chat/send-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },

  getFileDownloadUrl: (fileId, chatId) =>
    messengerApi.post(`/chat/file/${fileId}/download-url`, { chat_id: chatId })
};